import React, { useContext, useEffect, useState, Component } from "react";
import moment from "moment";
import { sortBy, isEmpty } from "lodash";

import WeeklyDetailsList from "./WeeklyDetailsList";
import WeeklyDetailsTotal from "./WeeklyDetailsTotal";
import { ExpenseReportsContext } from "../../ExpenseReportsContext";
import { addDates } from "./WeeklyDetails.utils";

const WeeklyDetails = ({ expenseReportsUserWeekly }) => {
  const { weekDate } = useContext(ExpenseReportsContext);
  const [newWeekObj, setNewWeekObj] = useState([]);
  const [expensesTypesList, setExpensesTypesList] = useState();

  const initializeWeekObj = weekFilterDate => {
    let weekTabSortedByDate = [];
    if (!isEmpty(expenseReportsUserWeekly) && expenseReportsUserWeekly[0] && !isEmpty(expenseReportsUserWeekly[0].data))
      weekTabSortedByDate = sortBy(expenseReportsUserWeekly[0].data, function(dateObj) {
        return dateObj.date;
      });

    let expenseReportsTypeList = [];
    if (!isEmpty(expenseReportsUserWeekly)) {
      const getUserWeeklyData = expenseReportsUserWeekly[0].data;

      expenseReportsTypeList = getUserWeeklyData.reduce((acc, item) => {
        if (item.type && !acc.includes(item.type.type)) acc.push(item.type.type);
        return acc;
      }, []);
      setExpensesTypesList(expenseReportsTypeList);
    }

    let weekObj = weekTabSortedByDate.reduce(
      (acc, item) => {
        if (acc.hasOwnProperty(moment(item.date).format("YYYY-MM-DD"))) {
          acc[moment(item.date).format("YYYY-MM-DD")].push(item);
        } else {
          const accKeys = Object.keys(acc);
          const lastKey = accKeys[accKeys.length - 1];
          const Difference_In_Time = Math.abs(moment(item.date).valueOf() - moment(lastKey).valueOf());
          let daysDiff = (Math.round(Difference_In_Time) / (1000 * 3600 * 24) - 1).toFixed(0);

          addDates(daysDiff, lastKey, acc);
          acc[moment(item.date).format("YYYY-MM-DD")] = [item];
        }

        return acc;
      },
      {
        [moment(weekFilterDate).format("YYYY-MM-DD")]: []
      }
    );

    const weekObjLength = Object.keys(weekObj).length;
    let missingDays = 7 - Object.keys(weekObj).length;

    return addDates(missingDays, Object.keys(weekObj)[weekObjLength - 1], weekObj);
  };

  const expenseReportsUserWeeklyList =
    expenseReportsUserWeekly && expenseReportsUserWeekly[0] && expenseReportsUserWeekly[0].data;

  useEffect(() => {
    if (!isEmpty(expenseReportsUserWeekly)) setNewWeekObj(initializeWeekObj(weekDate));
    else {
      setNewWeekObj([]);
      setExpensesTypesList();
    }
  }, [expenseReportsUserWeekly]);

  return (
    <div className="flex mb-5 justify-between">
      <WeeklyDetailsList
        weeklyExtraData={isEmpty(expenseReportsUserWeekly) ? [] : expenseReportsUserWeekly[0].extra_data}
        weeklyData={newWeekObj}
        expenseReportsTypeList={expensesTypesList}
      />
      <div className="mx-6 w-1/4 p-2">
        <WeeklyDetailsTotal weeklyList={expenseReportsUserWeeklyList} />
      </div>
      {/* <div className={"flex"}> // A mettre quand export ok.
          <div
            className="bg-blue-800 rounded-full text-white py-3 px-4 mr-2 cursor-pointer"
            onClick={() => {
              setModalOpen(!modalOpen);
              setModal("export");
            }}
          >
            Exporter les presence
          </div>
          <div className="bg-blue-800 rounded-full text-white py-3 px-4 mr-4 cursor-pointer">Exporter les trajets</div>
        </div> */}
    </div>
  );
};

export default WeeklyDetails;



// WEBPACK FOOTER //
// src/modules/presence/expenseReports/expenseReportsWeekly/weeklyDetails/WeeklyDetails.js